import type { IconData } from '@stacksjs/iconify-core'

export const screenSmartphone: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M104 48v416a32.036 32.036 0 0 0 32 32h248a32.036 32.036 0 0 0 32-32V48a32.036 32.036 0 0 0-32-32H136a32.036 32.036 0 0 0-32 32m280.021 416H136V48h248Z\"/><path fill=\"currentColor\" d=\"M216 80h96v32h-96zm32 312h32v32h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default screenSmartphone
